import PodStatus from './styled';

export default PodStatus;
